import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import SlidePanel from "../shared/SlidePanel";
import toast from "../shared/Toast";
import siteSetting from "../../config/env";
import { marketingAction } from "../../_actions/marketing.actions";
import { ChannelCards, getSmsText, marketingSelectProps } from "./MarketingEditorParts";

const NUM_REGEX = /^[0-9\b]+$/;

function ReminderPanel({ data, salonId, index, isCreate, onClose, onSaved }) {
  const dispatch = useDispatch();
  const [reminder, setReminder] = useState(
    isCreate
      ? { reminderTime: 0, reminderTimeType: null, statusSMSreminder: 0, statusEmailReminder: 0 }
      : { ...data }
  );
  const [reminderTime, setReminderTime] = useState(
    isCreate ? "" : data?.reminderTime != null ? String(data.reminderTime) : ""
  );
  const [timeOption, setTimeOption] = useState(
    !isCreate && data?.reminderTimeType
      ? { value: data.reminderTimeType, label: marketingAction.reminderTimeType(data.reminderTimeType) }
      : null
  );
  const [triggerError, setTriggerError] = useState(null);
  const [timeError, setTimeError] = useState(null);
  const [saving, setSaving] = useState(false);

  const options = siteSetting?.reminderTimeOptions;
  const canDelete = !isCreate && index > 0;

  const onTimeChange = (e) => {
    const v = e.target.value;
    if (v === "" || NUM_REGEX.test(v)) {
      setTriggerError(null);
      setReminderTime(v);
    } else {
      setTriggerError("Enter valid time in number.");
    }
  };

  const setStatus = (field, checked) =>
    setReminder((r) => ({ ...r, [field]: checked ? 1 : 0 }));

  const save = () => {
    if (+reminderTime <= 0) {
      setTriggerError("Trigger Time is required.");
      return;
    }
    if (!timeOption) {
      setTimeError("This field is required.");
      return;
    }
    setSaving(true);
    const onDone = (res) => {
      setSaving(false);
      if (res?.data?.statusCode === 1) {
        toast.success(res?.data?.responseData?.message);
        if (onSaved) onSaved();
      }
    };
    const fail = () => setSaving(false);

    if (isCreate) {
      const payload = {
        reminder: {
          ...reminder,
          reminderTime: +reminderTime,
          reminderTimeType: timeOption.value,
        },
        salonId: salonId || localStorage.getItem("salonId"),
        type: 2,
      };
      dispatch(marketingAction.addReminder(payload)).then(onDone).catch(fail);
    } else {
      const next = {
        ...reminder,
        reminderTime: +reminderTime,
        reminderTimeType: timeOption.value,
      };
      const payload = { reminders: [next], type: 2, salonId };
      dispatch(marketingAction.updateSetting(payload)).then(onDone).catch(fail);
    }
  };

  const remove = () => {
    setSaving(true);
    const payload = { reminderId: reminder?._id, type: 2, salonId };
    dispatch(marketingAction.removeReminder(payload))
      .then((res) => {
        setSaving(false);
        if (res?.data?.statusCode === 1) {
          toast.success(res?.data?.responseData?.message);
          if (onSaved) onSaved();
        }
      })
      .catch(() => setSaving(false));
  };

  const footer = (
    <>
      {canDelete ? (
        <button
          type="button"
          className="sp-btn-secondary"
          style={{ color: "#dc2626" }}
          onClick={remove}
          disabled={saving}
        >
          Delete
        </button>
      ) : (
        <button type="button" className="sp-btn-secondary" onClick={onClose}>
          Cancel
        </button>
      )}
      <button type="button" className="sp-btn-primary" onClick={save} disabled={saving}>
        Save
      </button>
    </>
  );

  return (
    <SlidePanel
      title={isCreate ? "Create Reminder" : data?.title || "Reminder"}
      onClose={onClose}
      footer={footer}
      width={520}
    >
      <p className="sp-hint" style={{ marginTop: 0, textAlign: "center" }}>
        Set when the reminders are sent before the clients appointment.
      </p>

      <div className="mkt-time-row" style={{ marginTop: 16, marginBottom: 4 }}>
        <div className="mkt-time-trigger">
          <label className="sp-label">Trigger Time</label>
          <input
            type="text"
            className="sp-input"
            style={{ textAlign: "center" }}
            value={reminderTime}
            onChange={onTimeChange}
          />
          {triggerError ? <div className="sp-error">{triggerError}</div> : null}
        </div>
        <div className="mkt-time-frame">
          <label className="sp-label">Timeframe</label>
          <Select
            value={timeOption}
            options={options}
            onChange={(e) => {
              setTimeOption(e);
              setTimeError(null);
            }}
            {...marketingSelectProps}
          />
          {timeError ? <div className="sp-error">{timeError}</div> : null}
        </div>
      </div>

      <ChannelCards
        smsTitle="SMS Reminder"
        emailTitle="Email Reminder"
        smsDesc={
          <>
            SMS reminders are sent to <b>all clients</b> before their appointment to cut
            down on no-shows.
          </>
        }
        emailDesc={
          <>
            Email reminders are sent to <b>all clients</b> before their appointment to
            cut down on no-shows.
          </>
        }
        statusSMS={reminder?.statusSMSreminder}
        statusEmail={reminder?.statusEmailReminder}
        onToggleSms={(c) => setStatus("statusSMSreminder", c)}
        onToggleEmail={(c) => setStatus("statusEmailReminder", c)}
        smsText={getSmsText("reminder")}
        emailType="Reminder"
      />
    </SlidePanel>
  );
}

export default ReminderPanel;
